import { useAppSelector } from "../redux/hooks";
import { GlobalHooks } from "../utils/Hooks";

const StatsP2PIntegrated = ({language ="fr", token}) => {

  const newStatsP2PIframe = "https:" +
    window.process.env.FO_STATS_URL + "/p2p"
    +  "?lng=" + language + "&token=" + token
  
    return (
      <iframe
        id="iframe_statsVideos_display"
        src={newStatsP2PIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default StatsP2PIntegrated